import React, { useState } from "react";
import { TextField, Button, Box } from "@mui/material";
import { Add, Upload, Reorder } from "@mui/icons-material";
import ReorderStationsDialog from "../dialogs/ReorderStationsDialog";
import { Station } from "../../api";

export type TabType = "stations" | "files";

interface StationsHeaderProps {
  searchTerm: string;
  onSearch: (term: string) => void;
  activeTab: TabType;
  onTabChange: (tab: TabType) => void;
  onCreateStation: () => void;
  onUploadFiles: () => void;
  canUploadFiles: boolean;
  stations: Station[];
  onReorderComplete?: () => void;
}

const StationsHeader: React.FC<StationsHeaderProps> = ({
  searchTerm,
  onSearch,
  activeTab,
  onTabChange,
  onCreateStation,
  onUploadFiles,
  canUploadFiles,
  stations,
  onReorderComplete
}) => {
  const [orderDialogOpen, setOrderDialogOpen] = useState(false);

  return (
    <div className="title-section">
      <h1 className="page-title">Stations</h1>
      <Box sx={{ display: 'flex', gap: 2 }}>
        <TextField
          placeholder="Search stations..."
          value={searchTerm}
          onChange={(e) => onSearch(e.target.value)}
          size="small"
        />
        <Button
          variant="contained"
          startIcon={<Add />}
          onClick={onCreateStation}
          className="create-button"
        >
          Add Station
        </Button>
        {canUploadFiles && (
          <Button
            variant="outlined"
            startIcon={<Upload />}
            onClick={onUploadFiles}
          >
            Upload Files
          </Button>
        )}
        <Button
          variant="outlined"
          startIcon={<Reorder />}
          onClick={() => setOrderDialogOpen(true)}
          className="text-primary border-primary hover:bg-primary/5"
        >
          Reorder Stations
        </Button>
      </Box>
      <ReorderStationsDialog
        open={orderDialogOpen}
        onClose={() => setOrderDialogOpen(false)}
        stations={stations}
        onReorderComplete={onReorderComplete}
      />
    </div>
  );
};

export default StationsHeader;
